/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { EnvironmentConfig, SignUpEnvironment } from 'app/sign-up/sign-up.model';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  standalone: false
})
export class SignUpComponent {
  firstName = '';
  lastName = '';
  company = '';
  jobTitle = '';
  email = '';
  consent = false;
  jsccTermsConsent = false;
  selectedEnvironment!: SignUpEnvironment;

  private redirectUrl?: string;

  message?: string;
  contactEmail?: string;
  isSubmitting = false;
  showSuccessPendingMessage = false;

  jsccTermsConditionsLink = `${environment.analyticsUrl}/assets/jscc-terms.pdf`;

  _environmentConfig!: EnvironmentConfig;
  @Input() set environmentConfig(config: EnvironmentConfig) {
    this._environmentConfig = config;
    const queryParams = parseQueryString(window.location.search.substr(1));
    const tenantParam = queryParams['tenantId'] || config.defaultEnvironment.queryParam;
    this.selectedEnvironment = config.signUpEnvironments.find(env => env.queryParam === tenantParam) || config.defaultEnvironment;
    this.email = queryParams['email'] || '';
    this.redirectUrl = queryParams['redirectUrl'];
  }

  constructor(private http: HttpClient) {
  }

  submit(): void {
    this.isSubmitting = true;
    this.http.post(environment.signUpUrl, {
      firstName: this.firstName,
      lastName: this.lastName,
      company: this.company,
      jobTitle: this.jobTitle,
      email: this.email,
      marketingOptIn: this.consent || false,
      ...(this.selectedEnvironment.jsccTermsConsentRequired && {
        jsccTermsConsent: this.jsccTermsConsent,
      }),
    }).subscribe({
      next: (data: any) => {
        this.isSubmitting = false;
        if (data.signupResponse == 'SUCCESS') {
          this.http.post(environment.loginUrl, {
            email: this.email,
            redirect: this.redirectUrl
          }).subscribe((response: any) => {
            this.message = response.errorMessage || 'Please check your inbox as you will shortly receive a link to log in.';
          });
        } else if (data.signupResponse == 'SUCCESS_PENDING') {
          this.showSuccessPendingMessage = true;
          this.message = undefined;
        } else {
          this.message = 'Something went wrong. If this issue persists please contact';
          this.contactEmail = 'support@opengamma.com';
        }
      },
      error: () => {
        this.message = 'Something went wrong. If this issue persists please contact';
        this.contactEmail = 'support@opengamma.com';
      }
    });
  }

  getTodayPlusOneWeek(): string {
    const now = new Date();
    now.setDate(now.getDate() + 7);
    const options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return now.toLocaleDateString('en-US', options);
  }

  protected readonly environment = environment;
}

// TODO this is duplicated
function parseQueryString(query: string): { [key: string]: string } {
  const vars = query.split('&');
  const queryString: { [key: string]: any } = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (typeof queryString[pair[0]] === 'undefined') {
      queryString[pair[0]] = decodeURIComponent(pair[1]);
    } else if (typeof queryString[pair[0]] === 'string') {
      queryString[pair[0]] = [queryString[pair[0]], decodeURIComponent(pair[1])];
    } else {
      queryString[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  return queryString;
}
